<template>
    <v-data-table :headers="headers" :items="parts" :loading="table_loader" hide-actions>
        <template slot="items" slot-scope="props">
            <tr class="clickable">
                <td v-if="props"></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </template>
        <template slot="no-data">
            <tr class="no-hover">
                <td class="w-100" :colspan="headers.length">
                    <v-layout>
                        <v-flex class="text-center align-content-center" :style="$bp.smallScreen ? 'margin-top:16px;' : 'height:calc(100vh - 300px)'">
                            <span class="blue-grey--text text--lighten-4 display-1">{{ table_loader ? $t("lang.loading") : $t("lang.no_shipments") }}</span>
                        </v-flex>
                    </v-layout>
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
export default {
    name: "shipments",
    data() {
        return {
            headers: [
                { text: this.$t("lang.packing_list_number_short"), sortable: false },
                { text: this.$t("lang.bol_number_short"), sortable: false },
                { text: this.$t("lang.customer"), sortable: false },
                { text: this.$t("lang.ship_to_address_id"), sortable: false },
                { text: this.$t("lang.date_shipped"), sortable: false },
            ],
            parts: [],
            settings: {
                maxScrollbarLength: 150,
            },
            table_loader: false,
        };
    },
    mounted: function () {
        // this.getParts();
    },
    methods: {
        getParts() {
            this.$store
                .dispatch("fetchPart", {
                    url: "parts",
                    method: "get",
                    body: {
                        company_id: this.customer_id,
                    },
                })
                .then((data) => {
                    if (typeof data !== "undefined") this.parts = data.parts;
                })
                .finally(() => {
                    this.table_loader = false;
                });
        },
        profile(id) {
            this.$router.push({ name: "part_profile", params: { id: id } });
        },
    },
};
</script>
